import Button from "@/components/ui/button";
import StarRatingInput from "../star-rating-input";
import StepLayout from "../step-layout";
import { useFeedbackFlow } from "../../hooks/use-feedback-flow";

interface StepRatingProps {
	appName: string;
}

export default function StepRating({ appName }: StepRatingProps) {
	const { data, setRating, nextStep, canProceed } = useFeedbackFlow();

	const handleContinue = () => {
		if (canProceed()) {
			nextStep();
		}
	};

	return (
		<StepLayout
			header={<h1 className="text-2xl font-semibold text-primary">Enjoying {appName}?</h1>}
			content={
				<>
					<p className="text-secondary mb-6">Your feedback helps us improve and create a better experience for you. Please take a moment to rate your experience so far.</p>
					<StarRatingInput value={data.rating} onChange={setRating} size="large" />
				</>
			}
			footer={
				<div className="flex justify-center">
					<Button onClick={handleContinue} disabled={!canProceed()} variant="brand" className="w-full">
						Continue
					</Button>
				</div>
			}
		/>
	);
}
